import { MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { sessionChangedError } from '@/utils/authFlow'

let pendingPrompt = null

export function attachRequestSession(config) {
  const token = config.skipAuth ? '' : (getToken() || '')
  config._authToken = token
  config._authVersion = store.state.user.sessionVersion
  config.headers = config.headers || {}
  if (token) config.headers['Authorization'] = token
  return config
}

export function authenticationError(config = {}, message) {
  const token = getToken() || ''
  const version = store.state.user.sessionVersion
  if (config._authVersion !== version || (!config.skipAuth && config._authToken !== token)) {
    return sessionChangedError()
  }
  const error = Object.assign(new Error(message || '登录已失效，请重新登录。'), { code: 401 })
  // 登录链路由登录页/路由守卫处理，避免多个弹窗和刷新争抢。
  if (config.authRequest || !token || pendingPrompt) return error

  const prompt = { token, version }
  pendingPrompt = prompt
  MessageBox.confirm('登录已失效，请重新登录后继续。', '重新登录', {
    confirmButtonText: '重新登录',
    cancelButtonText: '稍后处理',
    type: 'warning'
  }).then(async () => {
    // 旧请求和旧弹窗不能清除后来登录的新会话。
    if (getToken() === token && store.state.user.sessionVersion === version) {
      await store.dispatch('FedLogOut')
      location.reload()
    }
  }).catch(() => {}).then(() => {
    if (pendingPrompt === prompt) pendingPrompt = null
  })
  return error
}



// WEBPACK FOOTER //
// ./src/utils/authFailure.js